module.exports = __webpack_public_path__ + "static/media/NvphVents.7ae098dd.webp";